import axios from 'axios';
import apiConfig from '../api.config';

export default function pmsListRequest() {
  const {
    host,
    URIs: { pmsList },
  } = apiConfig;

  const uri = `${host}${pmsList}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
